export const normalizeCoordinateInput = (value) => {
  if (value === null || value === undefined) {
    return value;
  }
  const valueString = String(value);
  let cleaned = '';
  let hasDecimal = false;
  for (let index = 0; index < valueString.length; index += 1) {
    const char = valueString[index];
    if (char === '-' && cleaned.length === 0) {
      cleaned += char;
      continue;
    }
    if (char === '.' && !hasDecimal) {
      cleaned += char;
      hasDecimal = true;
      continue;
    }
    if (char >= '0' && char <= '9') {
      cleaned += char;
    }
  }
  return cleaned;
};

export const normalizeStateCodeInput = (value) => {
  if (value === null || value === undefined) {
    return value;
  }
  return String(value).trim().toUpperCase();
};

export const setNormalizedFormikValue = ({ formikBag, fieldId, value, normalizer }) => {
  if (!formikBag || !fieldId) {
    return;
  }
  const nextValue = typeof normalizer === 'function' ? normalizer(value) : value;
  formikBag.setFieldValue(fieldId, nextValue);
};
